module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-153.de5ceaa.woff2";